/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReassignableReservation
 */
export interface ReassignableReservation {
    /**
     * 
     * @type {string}
     * @memberof ReassignableReservation
     */
    localEndTime: string;
    /**
     * 
     * @type {string}
     * @memberof ReassignableReservation
     */
    localStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof ReassignableReservation
     */
    targetBookableId: string;
    /**
     * 
     * @type {string}
     * @memberof ReassignableReservation
     */
    reservationId: string;
}

/**
 * Check if a given object implements the ReassignableReservation interface.
 */
export function instanceOfReassignableReservation(value: object): value is ReassignableReservation {
    if (!('localEndTime' in value) || value['localEndTime'] === undefined) return false;
    if (!('localStartTime' in value) || value['localStartTime'] === undefined) return false;
    if (!('targetBookableId' in value) || value['targetBookableId'] === undefined) return false;
    if (!('reservationId' in value) || value['reservationId'] === undefined) return false;
    return true;
}

export function ReassignableReservationFromJSON(json: any): ReassignableReservation {
    return ReassignableReservationFromJSONTyped(json, false);
}

export function ReassignableReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReassignableReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'localEndTime': json['localEndTime'],
        'localStartTime': json['localStartTime'],
        'targetBookableId': json['targetBookableId'],
        'reservationId': json['reservationId'],
    };
}

export function ReassignableReservationToJSON(value?: ReassignableReservation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'localEndTime': value['localEndTime'],
        'localStartTime': value['localStartTime'],
        'targetBookableId': value['targetBookableId'],
        'reservationId': value['reservationId'],
    };
}

